// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".chat[data-v-27b0ee66]{height:100vh}.center[data-v-27b0ee66]{margin-top:100px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
